<template>
  <Doughnut
    :chart-options="getChartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
    ref="doughnutChart"
  />
</template>

<script>
import { Doughnut } from "vue-chartjs/legacy";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale
} from "chart.js";

import { themeObserver, Themes } from '../../commons/colors';

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale
);
ChartJS.defaults.font.family = "ui-sans-serif, -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, 'Apple Color Emoji', Arial, sans-serif, 'Segoe UI Emoji', 'Segoe UI Symbol'";
ChartJS.defaults.font.size = 12;

export default {
  components: {
    Doughnut
  },
  props: {
    chartId: {
      type: String,
      default: 'doughnut-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Array,
      default: () => []
    },
    chartOptions: Object,
    chartData: Object,
  },
  data: () => ({
    observer: null,
    color: Themes.light.gray700
  }),
  methods: {
    updateChart() {
      this.$refs.doughnutChart.updateChart();
    }
  },
  computed: {
    getChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        borderWidth: 0,
        offset: 6,
        color: this.color,
        cutout: "65%",
        layout: {
          padding: {
            top: 3,
            bottom: 3
          }
        },
        plugins: {
          legend: {
            position: "right",
            labels: {
              boxWidth: 6,
              boxHeight: 6,
              usePointStyle: true,
            }
          },
          tooltip: {
            boxWidth: 6,
            boxHeight: 6,
            boxPadding: 3,
            usePointStyle: true,
          }
        },
        ...this.chartOptions,
      }
    },
  },
  mounted() {
    const target = document.body;
    const setColor = () => {
      if (target.classList.contains('dark')) {
        this.color = Themes.dark.gray700;
      } else {
        this.color = Themes.light.gray700;
      }
    }
    setColor();
    /* mutation observer */
    this.observer = themeObserver(target, setColor, "do");
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}
</script>